import React, {FC, ChangeEvent} from 'react'
import {IPermission} from '../../../../modules/auth/models/PermissionsModel'
import {UserPermission, hasPermission} from '../../../../modules/utils/UserPermissions '
import {IScreenModel} from '../../../../models/IScreenModel'
import { LIST_SCREENS } from '../../../../constants/common'

interface PermissionComponentProps {
  listScreen: IScreenModel[]
  selectedRole: string | null
  selectedRolePermissions: IPermission[] | null
  handleCheckedPermission: (e: ChangeEvent<HTMLInputElement>, permission: IPermission) => void
}

const PermissionComponent: FC<PermissionComponentProps> = ({
  listScreen,
  selectedRole,
  selectedRolePermissions,
  handleCheckedPermission,
}) => {
  const permissionName = (permissionName: string): string => {
    const translations: Record<string, string> = {
      list: 'Xem',
      create: 'Tạo mới',
      update: 'Sửa',
      delete: 'Xóa',
    }
    const parts = permissionName.split('-')
    const lastPart = parts[parts.length - 1]
    return translations[lastPart] || lastPart
  }

  const renderScreenPermissions = (screenList: any[]) => {
    return screenList?.map((item: any) => {
      let screenData = listScreen.find((el) => el.model === item.model)
      let childItems: any[] = item.childs ?? [];

      return (
        <div key={item.model} className={item.model === 'dashboard' ? 'd-none' : 'col-12 mb-3 border-bottom'}>
          {screenData?.permissions.map((p) => (
            <>
              <div key={p.id} className={p.name==='dashboard' ? 'd-none' : 'form-check my-2'} >
                <label className='form-check-label mx-2 fw-bold fs-4'>
                  {item.label ?? p.label}
                  <input
                    className='cursor-pointer form-check-input mx-2 fs-5'
                    type='checkbox'
                    disabled={true}
                    checked={ p.name ==='dashboard' ? true : 
                      (selectedRolePermissions
                        ? hasPermission(selectedRolePermissions, p.name)
                        : false)
                    }
                    onChange={(e) => handleCheckedPermission(e, p)}
                  />
                </label>
              </div>
              <div className='sub-nav'>
                {childItems && renderScreenPermissions(childItems)}
              </div>
            </>
          ))}
        </div>
      )
    })
  }

  return (
    <>
      {selectedRole ? (
        <div>
          <div className='fw-bold fs-5 border-bottom my-5'>Quyền hạn của vai trò</div>
          <div className='row'>
            <div className='permissions-container'>
              {renderScreenPermissions(LIST_SCREENS)}
            </div>
          </div>
        </div>
      ) : (
        <div className='text-center'>Vui lòng chọn vai trò</div>
      )}
      
    </>
  )
}

export default PermissionComponent
